import axiosErrorHandler from "./apiError.handler";
import http from "./axios";

async function apiGetLocationBreadcrumbsPath(locationId: string): Promise<ApiBreadcrumbItemDto[]> {
  try {
    const queryString = `LocationUtility/Breadcrumbs?locationId=${locationId}`;
    const { data } = await http.get(queryString);
    return data;
  } catch (error: unknown) {
    throw axiosErrorHandler(error, "Error while loading location breadcrumbs");
  }
}

export default apiGetLocationBreadcrumbsPath;
